import { OurTeamType } from "./types";

export const ourTeamContents: OurTeamType[] = [
  {
    id: 0,
    title: "امیر صفائی",
    description: "مدیرعامل",
    url: "/assets/images/aboutUsPage/ourTeam/amir.png",
  },
  {
    id: 1,
    title: "علی وزیری",
    description: "سرپرست فنی",
    url: "/assets/images/aboutUsPage/ourTeam/ali.png",
  },
  {
    id: 2,
    title: "مهرنوش رمضان پور",
    description: "طراح محصول",
    url: "/assets/images/aboutUsPage/ourTeam/mehrnoosh.png",
  },
  {
    id: 3,
    title: "محسن حق‌گو",
    description: "برنامه نویس",
    url: "/assets/images/aboutUsPage/ourTeam/mohsen.png",
  },
];
